import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=168ce8c3&scoped=true&"
import script from "./Permissions.vue?vue&type=script&lang=js&"
export * from "./Permissions.vue?vue&type=script&lang=js&"
import style0 from "./Permissions.vue?vue&type=style&index=0&id=168ce8c3&scoped=true&lang=css&"
import style1 from "./Permissions.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168ce8c3",
  null
  
)

export default component.exports